<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header bg-accent-grad glow-accent text-center">
                        <h4 class="text-white mb-0">فرم ثبت فیش بانکی پرداختی</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <!--<div class="col-12 text-center">-->
                            <!--<div class="profile-image">-->
                            <!--<img :src="paymentModel.userImage" class="img-fluid">-->
                            <!--</div>-->
                            <!--<input type="file" id="fileUpload" class="d-none"-->
                            <!--@change="onProfileImageChange($event)">-->
                            <!--<label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری-->
                            <!--تصویر</label>-->
                            <!--</div>-->
                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">بانک مقصد</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               :data="banks" :mode="'create'"
                                               :header="{multiple: false, label: 'bankName'}"
                                               @onChange="onTypeChange">
                                    </vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کل مبلغ واریز شده</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="totAm"
                                           placeholder="مبلغی که واریز کرده اید را وارد کنید">
                                </div>
                                <!--<small>حداکثر وام درخواستی 5 میلیون تومان میباشد</small>-->
                            </div>
                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ فیش</span>
                                    </div>
                                    <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked" :auto-submit="true"
                                                 ref="birthDay" style="flex: 1">
                                        <slot>
                                            <input v-model="birthDate"
                                                   class="form-control date-input flex-grow-1"
                                                   @click="toggleCreateDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>

                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره پیگیری فیش</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="paymentModel.ReceiptNumber"
                                           placeholder="شماره پیگیری را وارد کنید">
                                </div>
                                <!--<small>حداکثر وام درخواستی 5 میلیون تومان میباشد</small>-->
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مبلغ قسط </span>
                                    </div>
                                    <input class="form-control" type="number" v-model="loanAm"
                                           placeholder="اگر پرداخت شما بابت قسط بوده مبلغ را وارد کنید">
                                </div>
                                <small>اگر پرداخت شما <u><b>بابت قسط</b></u>  بوده مبلغ را وارد کنید</small>
                            </div>
                            <div class="col-lg-8 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">توضیحات قسط</span>
                                    </div>
                                    <input class="form-control" type="text"
                                           v-model="des1"
                                           placeholder="اگر پرداخت شما بابت قسط بوده شرح اقساط را وارد کنید">
                                </div>
                                <small>اگر پرداخت شما <u><b>بابت قسط</b></u> بوده شرح اقساط را وارد کنید</small>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مبلغ سپرده</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="desAm"
                                           placeholder="اگر پرداخت شما بابت سپرده بوده مبلغ را وارد کنید">
                                </div>
                                <small>اگر پرداخت شما <u><b>بابت سپرده</b></u> بوده مبلغ را وارد کنید</small>
                            </div>
                            <div class="col-lg-8 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">توضیحات سپرده</span>
                                    </div>
                                    <input class="form-control" type="text"
                                           v-model="des2"
                                           placeholder="اگر پرداخت شما بابت سپرده بوده توضیحات را وارد کنید">
                                </div>
                                    <small>اگر پرداخت شما <u><b>بابت سپرده</b></u> بوده توضیحات را وارد کنید</small>
                                <!--<small>حداکثر تعداد ماه اقساط 24 ماه میباشد</small>-->
                            </div>
                            <!--<div class="col-lg-4 mb-4">-->
                            <!--<div class="input-group round">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">محل تولد</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" v-model="paymentModel.birthplace">-->
                            <!--</div>-->
                            <!--</div>-->


                            <div class="col-lg-12 text-center my-4">
                                <button class="btn btn-primary btn-round" @click="submitUserForm">ثبت اطلاعات</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import DatePicker from '../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../_framework/VsSelect";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus";

    export default {
        name: "newpayment",
        components: {VsSelect, DatePicker},
        data() {
            return {
                paymentModel: {
                    ReceiptNumber: 0,
                    ReceiptDate: "",
                    BankAccountId: 0,
                    Description: "",
                    LoanAmount: 0,
                    DepositAmount: 0,
                    TotalAmount: 0,
                    DocumentDate:"",

                },
                preselectedUserGender: {},
                preselectedUserProvince: {},
                preselectedUserCity: {},
                userGender: [
                    {
                        name: "مرد",
                        value: true
                    },
                    {
                        name: "زن",
                        value: false
                    }
                ],
                city: [],
                province: [],
                isLoading: false,
                birthDate: "",
                banks: [],
                des1: "",
                des2: "",

                desAm: 0,
                loanAm: 0,
                totAm: 0,


            }
        },
        mounted() {

            // this.getProvince();
            // this.paymentModel.userImage = this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(this.paymentModel.userImage)));
            // this.paymentModel.userImage = this.validateImageUrl(this.paymentModel.userImage);
            this.GetBanks();
            // this.loanAm = this.totAm - this.desAm;
            // console.log(this.totAm);
        },
        methods: {
            GetBanks() {
                new BaseService("BankReceipt", "/GetBanks").getList().then(response => {
                    this.banks = response.data.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onTypeChange(val) {
                if (val !== null) {
                    this.paymentModel.BankAccountId = val.id;
                }
            },
            // confirmUserData() {
            //     if(this.reportModel.loanTypeId === 0){
            //         Utils.handleErrorWithNotification("لطفا نوع وام درخواستی را مشخص کنید", this.$noty);
            //     }else {
            //         this.isLoading = true;
            //         new BaseService("Request", "/NewRequest").getList(this.paymentModel).then(response => {
            //             this.isLoading = false;
            //             // console.log(response.data)
            //             this.$noty.success('درخواست شما با موفقیت ثبت شد', {timeout: 1000})
            //             this.$router.push({name: "home"})
            //         }).catch(error => {
            //             Utils.handleErrorWithNotification(error.data, this.$noty);
            //         });
            //     }
            // },

            //
            onCreateDatePicked(val) {
                this.birthDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.paymentModel.DocumentDate = val;
                this.paymentModel.ReceiptDate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
                // console.log(this.paymentModel.DocumentDate);
            },
            toggleCreateDatePicker() {
                this.$refs.birthDay.togglePicker();
                // console.log("startDate");

            },
            // onProfileGenderChange(val) {
            //     if (val) {
            //         this.paymentModel.male = val.value
            //     }
            // },
            // onProfileCityChange(val) {
            //     if (val) {
            //         this.paymentModel.cityId = val.id;
            //     } else {
            //         // this.competitionCity = []
            //     }
            //
            // },
            // onProfileProvinceChange(val) {
            //     if (val) {
            //         this.paymentModel.provinceId = val.id;
            //         if (val.id !== undefined) {
            //             this.getCities(val.id);
            //         }
            //     } else {
            //         this.city = []
            //     }
            // },
            // onProfileImageChange(e) {
            //     let files = e.target.files;
            //     let app = this;
            //     if (files && files[0]) {
            //         for (let item of files) {
            //             let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
            //             if (extension === "jpg" || extension === "JPG" ||
            //                 extension === "png" || extension === "PNG" ||
            //                 extension === "JPEG" || extension === "jpeg") {
            //                 let reader = new FileReader();
            //                 reader.onload = function (e) {
            //                     // $("#bannerImg").attr("src", e.target.result);
            //                     app.paymentModel.userImage = e.target.result;
            //                 };
            //                 reader.readAsDataURL(item);
            //             } else {
            //                 alert("لطفا فایل عکس بارگذاری کنید");
            //             }
            //         }
            //     }
            // },
            submitUserForm() {
                if (this.totAm === 0) {
                    Utils.handleErrorWithNotification("لطفا مبلغ را وارد کنید", this.$noty);
                } else {
                    if (this.paymentModel.ReceiptDate === null || this.paymentModel.ReceiptDate === "") {
                        Utils.handleErrorWithNotification("لطفا تاریخ را وارد کنید", this.$noty);
                    } else {
                        if (this.paymentModel.BankAccountId === 0) {
                            Utils.handleErrorWithNotification("لطفا بانک را انتخاب کنید", this.$noty);
                        } else {
                            // console.log(this.totAm);
                            // console.log(this.desAm);
                            // console.log(this.loanAm);
                            // console.log(Number(this.totAm));
                            // console.log(Number(this.desAm) + Number(this.loanAm));
                            if (Number(this.totAm) !== Number(this.desAm) + Number(this.loanAm)) {
                                Utils.handleErrorWithNotification("لطفا مبلغ قسط را مجددا و صحیح وارد کنید", this.$noty);
                            } else {
                                this.isLoading = true;
                                this.paymentModel.Description = this.des1 + " و " + this.des2;
                                this.paymentModel.TotalAmount = this.totAm;
                                this.paymentModel.DepositAmount = this.desAm;
                                this.paymentModel.LoanAmount = this.loanAm;

                                new BaseService("BankReceipt", "/NewBankReceipt").create(this.paymentModel).then(response => {
                                    this.isLoading = false;
                                    // console.log(response.data)
                                    this.$noty.success('پرداخت شما با موفقیت ثبت شد', {timeout: 1000})
                                    this.$router.push({name: "home"})
                                }).catch(error => {
                                    Utils.handleErrorWithNotification(error.data, this.$noty);
                                });
                            }
                        }
                    }
                }
            },
            validateProfilePlaceholder(img) {
                // let final = img.substr(img.lastIndexOf('/') + 1);
                // let file = final.split('.');
                // return "/img/" + file[0] + '.' + file[2];
            }
        },
        watch: {
            totAm: {
                handler(val) {
                    this.totAm = val;
                    // this.desAm = val - this.loanAm;
                    this.loanAm = val - this.desAm;
                }
            },
            // loanAm: {
            //     handler(val) {
            //         console.log("loan" + val);
            //         // this.loanAm = this.totAm - val - this.desAm;
            //         // this.desAm = this.totAm - val;
            //     }
            // },
            desAm: {
                handler(val) {
                    this.loanAm = this.totAm - val;
                    // this.desAm = this.totAm - val - this.loanAm;
                }
            }
        },

    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>